import {createWebHistory, createRouter} from "vue-router";

import Home from './view/Home.vue';
import GardenConf from './view/GardenConf.vue';
import MaintenanceConf from './view/MaintenanceConf.vue';
import Configurator from './components/Configurator.vue';
import PageNotFound from './view/PageNotFound.vue';
import PageError from './view/PageError.vue';
import RealizationConf from "./view/RealizationConf";

const DEFAULT_TITLE = 'Zelená kalkulačka';
const MAIN_TITLE = 'Zelené kolo';

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home,
	},
	{
		path: '/konfigurator-zahrad',
		name: 'garden-conf',
		component: GardenConf,
		meta: {
			title: 'Kalkulačka projektů'
		},
		children: [
			{
				path: 'projekt-cele-zahrady',
				name: 'garden-conf-whole',
				component: Configurator,
				meta: {
					title: 'Kalkulačka projektů - projekt celé zahrady'
				}
			},
			{
				path: 'konkretni-prvek',
				name: 'garden-conf-part',
				component: Configurator,
				meta: {
					title: 'Kalkulačka projektů - konkretní prvek'
				}
			},
		]
	},
	{
		path: '/udrzba-zahrad',
		name: 'maintenance-conf',
		component: MaintenanceConf,
		meta: {
			title: 'Kalkulačka údržby'
		},
		children: [
			{
				path: 'zahrada-jako-celek',
				name: 'maintenance-conf-whole',
				component: Configurator,
				meta: {
					title: 'Kalkulačka údržby - údržba celé zahrady'
				}
			},
			{
				path: 'konkretni-prvek',
				name: 'maintenance-conf-part',
				component: Configurator,
				meta: {
					title: 'Kalkulačka údržby - konkretní prvek'
				}
			},
		]
	},
	{
		path: '/realizace-zahrad',
		name: 'realization-conf',
		component: RealizationConf,
		meta: {
			title: 'Kalkulačka realizace'
		},
		children: [
			{
				path: 'dle-ceny',
				name: 'realization-conf-price',
				component: Configurator,
				meta: {
					title: 'Kalkulačka realizace - dle ceny'
				}
			},
			{
				path: 'dle-typu',
				name: 'realization-conf-type',
				component: Configurator,
				meta: {
					title: 'Kalkulačka realizace - dle typu'
				}
			},
			{
				path: 'dle-sebe',
				name: 'realization-conf-own',
				component: Configurator,
				meta: {
					title: 'Kalkulačka realizace - vlastní'
				}
			},
		]
	},
	{
		path: '/:catchAll(.*)',
		component: PageNotFound,
		meta: {
			title: '404 - stránka nenalezena'
		}
	},
	{
		path: '/404',
		component: PageError,
		meta: {
			title: '404 - stránka nenalezena'
		}
	}
];

const router = createRouter({
	history: createWebHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		return {top: 0, behavior: 'smooth'}
	}
});

router.beforeEach((to, from) => {
	document.title = (to.meta.title || DEFAULT_TITLE) + ' | ' + MAIN_TITLE;
});

export default router;
